export type UseScrollToErrorQueryOptions = {
  /** Пропускать узлы (например блок общих ошибок с тем же классом, что и у поля) */
  exclude?: (el: HTMLElement) => boolean
  /**
   * Пропускать узлы без текста (заглушки: CitySearch/FileField всегда рендерят span.error-message).
   */
  skipEmpty?: boolean
}

export const useScrollToError = (
    errorClass: string = 'error-message',
    queryOptions?: UseScrollToErrorQueryOptions,
) => {
    const scrollToFirstError = async (options: ScrollIntoViewOptions = {
        behavior: 'smooth',
        block: 'center'
    }) => {
        // Ждем обновления DOM
        await nextTick();
        await new Promise(resolve => setTimeout(resolve, 100));

        let firstErrorElement: HTMLElement | null = null
        for (const node of document.querySelectorAll(`.${errorClass}`)) {
            if (!(node instanceof HTMLElement)) continue
            if (queryOptions?.exclude?.(node)) continue
            if (queryOptions?.skipEmpty && !node.textContent?.trim()) continue
            firstErrorElement = node
            break
        }
        if (!firstErrorElement) return false;
        const isVisible = await new Promise(resolve => {
            const observer = new IntersectionObserver(([entry]) => {
                observer.disconnect();
                resolve(entry.isIntersecting);
            }, { threshold: 0.1 });
            observer.observe(firstErrorElement);
        });

        const rect = firstErrorElement.getBoundingClientRect();
        const isCloseToTop = rect.top <= 100; 
        if (!isVisible || isCloseToTop) {
            firstErrorElement.scrollIntoView(options);
        }

        // Фокус на ближайший инпут
        const nearestInput = firstErrorElement.parentNode?.querySelector('input:not([disabled]), textarea:not([disabled]), select:not([disabled])') as HTMLElement | null;
        nearestInput?.focus({preventScroll: true});

        return true;
    };

    return { scrollToFirstError };
};